import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import PageWrap from '../../components/PageWrap/PageWrap'
import { FilterContextProvider } from '../../context/FilterContext'
import { TABLE_TYPES } from '../../enums/enumTableTypes'
import TableContractForms from '../../tables/TableContractForms/TableContractForms'

const FormulareZakazkyPage = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  return (
    <PageWrap
      title={t('title.formulare_zakazky', 'Formuláře zakázky')}
      subtitle={t('title.evidencni_cislo', 'Evidenční číslo zakázky:') + ' ' + id}
    >
      <FilterContextProvider name={TABLE_TYPES.contractForms}>
        <TableContractForms id={id!} />
      </FilterContextProvider>
    </PageWrap>
  )
}

export default FormulareZakazkyPage
